import React, { useEffect, useState, useRef, useCallback, } from "react";
import "../CSS/Header.css";
import HeaderSelect from "../../src/components/Modal/HeaderSelectModal";
import { API_BASE_URL } from "../config/serverApiConfig";
import SearchModal from "./Modal/GlobalSearchModal";
import ErrorBar from "../../src/components/Loader/SearchBarError";
import Profiles from "../components/Loader/SearchEmp";
import Cookies from "js-cookie";
import { debounce } from "lodash";
import { RiCloseLargeLine, RiSearch2Line } from "@remixicon/react";

let currentFetchController = null;

const Header = (props) => {
  const [ModalOpen, setModalOpen] = useState(false);
  const [value, setValue] = useState("");
  const [SearchOpen, setSearchOpen] = useState(false);
  const [filterData, setFilterData] = useState([]) as any;
  const [data, setData] = useState([]);
  const [dataLength, setDataLength] = useState(0);
  const [inputStatus, setInputStatus] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [Loadspinner, setLoadSpinner] = useState(false);
  const Modal = () => {
    setModalOpen(!ModalOpen);
  };

  const ref = useRef();

  useOnClickOutside(ref, () => {
    setSearchOpen(false);
  });

  function useOnClickOutside(ref, handler) {
    useEffect(() => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }, [ref, handler, SearchOpen]);
  }

  const fetchProfiles = async (searchTerm: string, signal?: AbortSignal) => {
    setIsLoadingData(true);
    return await fetch(API_BASE_URL + `getProfiles?search=${searchTerm}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
      signal,
    })
      .then((resD) => resD.json())
      .then((reD) => reD)
      .catch((err) => {
        if (err.name === "AbortError") return { data: [] }; // Ignore abort errors
        return err;
      });
  };

  const debouncedFetchProfiles = useCallback(
    debounce(async (searchTerm) => {
      if (currentFetchController) {
        currentFetchController.abort();
      }
      // Create a new controller for this request
      currentFetchController = new AbortController();

      const result = await fetchProfiles(searchTerm, currentFetchController.signal);
      if (result?.data?.length) {
        setFilterData([...result.data]);
        setSearchOpen(true);
        setSpinner(false);
      } else {
        setFilterData([]);
        setSearchOpen(false);
        setSpinner(true);
      }
    }, 200),
    []
  );

  useEffect(() => {
    return () => {
      debouncedFetchProfiles.cancel(); // Cleanup on unmount
      if (currentFetchController) {
        currentFetchController.abort();
      }
    };
  }, [debouncedFetchProfiles]);

  const searchProfiles = (e) => {
    const searchTerm = e.target.value;

    setValue(searchTerm);
    setSpinner(true);

    if (searchTerm && searchTerm !== " " && searchTerm.length >= 2) {
      debouncedFetchProfiles(searchTerm);
    } else {
      setSearchOpen(false);
      setSpinner(false);
    }
  };

  return (
    <>
      <div className="tw-flex tw-w-full tw-bg-white tw-p-4 tw-rounded-b-xl tw-shadow-lg">
        <div className="tw-flex-1">
          <div className="row">
            <div className="d-flex">
              <a
                className="nav-link  p-0"
                aria-current="page"
                onClick={() => window.open("/addCustomer")}
                style={{ backgroundColor: "none", marginRight: "10px" }}
              >
                <button className="btn btn-1">ADD CUSTOMER</button>
              </a>

              <a
                className="nav-link p-0"
                onClick={() => window.open("/addCandidate")}
              >
                <button className="btn btn-2"> Add Candidate</button>
              </a>
            </div>
          </div>
        </div>

        <div className="tw-flex-1">
          <div className="row text-end">
            <div className="d-flex justify-content-end">
              <div className="d-flex cursor-pointer tw-relative" onClick={() => setModalOpen(!ModalOpen)}>
                <div className="HeaderModalSelect">
                  <img alt="..." src={require("../images/headerSelect.svg").default} />
                </div>
                <div className="d-flex justify-content-center align-items-center ml-1">
                  <img alt="..." src={require("../images/Vector-9.svg").default} />
                </div>
                {ModalOpen ? (
                  <HeaderSelect closeModal={setModalOpen} />
                ) : null}
              </div>

              <div
                className="d-flex mx-2"
                style={{
                  background: "#F5F6F8",
                  border: "1px solid #ADADAD",
                  borderRadius: "26px",
                  width: "82%",
                }}
              >
                <div className="d-flex align-items-center pl-1">
                  <img alt="..." src={require("../images/searchIcon.svg").default} />
                </div>

                <input
                  style={{ border: "0px", background: "#F5F6F8" }}
                  value={value}
                  onChange={searchProfiles}
                  className="searcInputbOx pl-1"
                  placeholder="Search Name, Phone, Work, Jobs..."
                />

                {spinner ? (
                  <div
                    className="tw-flex tw-items-center tw-justify-center tw-animate-spin tw-mr-4"
                    role="status"
                  >
                    <svg
                      className="tw-h-8 tw-w-8 tw-text-gray-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 100"
                      preserveAspectRatio="xMidYMid"
                      display="block"
                    >
                      <circle
                        cx="50"
                        cy="50"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="10"
                        r="35"
                        strokeDasharray="164.93361431346415 56.97787016335404"
                      >
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          repeatCount="indefinite"
                          dur="1s"
                          values="0 50 50;360 50 50"
                          keyTimes="0;1"
                        ></animateTransform>
                      </circle>
                    </svg>
                  </div>
                ) : (
                  value.length ?
                    <div className="tw-flex tw-justify-center tw-items-center tw-pr-4">
                      <RiCloseLargeLine onClick={() => {
                        setValue("");
                        setSearchOpen(false);
                      }} className="tw-text-md tw-font-medium cursor-pointer tw-flex tw-items-center" color="gray" />
                    </div>
                    : <div className="tw-flex tw-justify-center tw-items-center tw-pr-4">
                      <RiSearch2Line className="tw-text-md tw-font-medium cursor-pointer tw-flex tw-items-center" color="gray" />
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {SearchOpen ? (
        <div
          className={
            filterData.length > 0 ? "tw-my-1 tw-rounded-xl tw-max-h-56 tw-overflow-y-auto tw-bg-white custom-scrollbar" : "tw-bg-white tw-my-1 tw-flex tw-justify-center tw-items-center tw-rounded-lg tw-min-h-20"
          }
        >
          {filterData.length > 0 ? (
            filterData.map((el, i) => (
              <SearchModal
                props={el}
                closeModal={setSearchOpen}
                setSearchValue={setValue}
                key={i}
              />
            ))
          ) : (
            <div ref={ref} className="tw-flex tw-items-center tw-justify-center">
              <ErrorBar />
              <p>
                No Candidate/Client Found! Please Enter Valid Name or Phone Number.
              </p>
            </div>
          )}
        </div>
      ) : null}
    </>
  );
};
export default Header;
